import Section1 from "./Section1";
import StartEarningToday from "./StartEarningToday";
import HowItWorks from "./HowItWorks";
import CarCriteria from "./CarCriteria";
import readytodrive from "images/readytodrive.png";
import { Helmet } from "react-helmet";
import DreamCarSection from "components/DreamYourCar/DreamYourCar";
import ReadytoDrive from "containers/PageAbout/ReadytoDrive";


function StartEarning() {
  return (
    <div className="nc-PageHome3 relative overflow-hidden">
      <Helmet>
        <title>Start Earning</title>
      </Helmet>

      
        <div className="container">
          <Section1 className="" />
        </div>
 

      <div className="container relative py-16 ">
        <StartEarningToday />
      </div>
      <div className=" relative ">
        <HowItWorks />
      </div>
      <div className="container relative py-16">
        <DreamCarSection />
      </div>
     
     
    </div>
  );
}

export default StartEarning;
